import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";

export const ShareServiceButton = ({ service, className = "" }) => {
    const [copied, setCopied] = useState(false);
    const share = async (e) => {
        e.preventDefault();
        const url = `${window.location.origin}/book?service=${service.id}`;
        if (navigator.share) {
            try { await navigator.share({ title: service.title, text: service.description, url }); } catch (_) { /* cancelled */ }
            return;
        }
        await navigator.clipboard.writeText(url);
        setCopied(true);
        toast.success("Service link copied");
        setTimeout(() => setCopied(false), 2000);
    };
    return (
        <button
            onClick={share}
            data-testid={`share-service-${service.id}`}
            aria-label={`Share ${service.title}`}
            className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full border border-[hsl(var(--border))] text-[hsl(var(--primary))] hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--accent))] transition-colors ${className}`}
        >
            {copied ? <Check size={13} /> : <Share2 size={13} />} {copied ? "Copied" : "Share"}
        </button>
    );
};
